/**
 * Grilla de tarjetas de producto.
 *
 * Es una lista de verdad (`<ul>`): un lector de pantalla anuncia cuantos
 * productos hay antes de empezar a leerlos, que es justo lo que se necesita
 * saber en un listado de catalogo.
 *
 * `titula` existe por la jerarquia de encabezados. El nombre de cada producto es
 * un `<h3>`, asi que la grilla necesita un `<h2>` por encima. En la portada ese
 * `<h2>` ya lo pone la seccion que la contiene ("Lo que mas sale del taller"); en
 * un listado de categoria, en cambio, arriba solo esta el `<h1>` y sin este
 * encabezado la pagina saltaria de `h1` a `h3`. Va oculto a la vista porque el
 * `<h1>` de la pagina ya dice lo mismo en pantalla.
 */
import { useId } from 'react';

import type { ProductoResumen } from '@bandu/compartido';

import { TarjetaProducto } from './TarjetaProducto';

/** Cuantas tarjetas se cargan sin diferir: las que caben en la primera pantalla. */
const SIN_DIFERIR = 4;

export interface GrillaProductosProps {
  productos: ProductoResumen[];
  /** Nombre de la lista, p. ej. "Productos de Abrasivos". */
  titulo: string;
  /** true cuando encima de la grilla no hay ningun `<h2>` que la nombre. */
  titula?: boolean;
}

export function GrillaProductos({ productos, titulo, titula = false }: GrillaProductosProps) {
  const idTitulo = useId();

  return (
    <>
      {titula ? (
        <h2 className="solo-lectores" id={idTitulo}>
          {titulo}
        </h2>
      ) : null}

      <ul
        className="grilla-prod"
        {...(titula ? { 'aria-labelledby': idTitulo } : { 'aria-label': titulo })}
      >
        {productos.map((producto, indice) => (
          <li key={producto.id}>
            <TarjetaProducto producto={producto} prioridad={indice < SIN_DIFERIR} />
          </li>
        ))}
      </ul>
    </>
  );
}
